import { useStore } from '@nanostores/react';
import { musicState, playTrack, stopMusic, setVolume, togglePlayPause, type TrackName } from '../stores/musicStore';

export const useMusic = () => {
  const state = useStore(musicState);
  
  return {
    ...state,
    playTrack: (trackName: TrackName) => playTrack(trackName),
    stopMusic,
    setVolume,
    togglePlayPause
  };
};
